export const EnforceShiftsOverviewV2 = 'enforce-shifts-overview-v2';
export const EnforceOfficeDashboardV2 = 'ARF-881-enforce-office-dashboard-v2';
